<app-navbar></app-navbar>
    <ngx-ui-loader></ngx-ui-loader>
    <div id="app">
        <router-outlet></router-outlet>
    </div>
<app-footer></app-footer>
<app-canonical></app-canonical>